import React, {Component} from "react";
import './index.css'
import Modal, {ModalContent, ModalControls} from "../Modal";
import Button from "../Control/Button";
import PropTypes from 'prop-types'

const PromptControl = {
    YES_NO: 'YES_NO',
    YES_NO_CANCEL: 'YES_NO_CANCEL',
    OK_CANCEL: 'OK_CANCEL',
    YES: 'YES',
    NO: 'NO',
    OK: 'OK',
    CANCEL: 'CANCEL'
};

const PromptControlText = {
    YES: 'بله',
    NO: 'خیر',
    OK: 'تایید',
    CANCEL: 'لغو'
};

class Prompt extends Component {
    constructor(props) {
        super(props);

        this.state = {
            title: props.title,
            description: props.description,
            theme: props.theme,
            size: props.size,
            buttons: props.buttons,
            onClose: props.onClose,
            resolve: _ => null,
            reject: _ => null
        };

        this.ref = {
            modal: React.createRef()
        };
    }

    static defaultProps = {
        title: null,
        description: null,
        theme: null,
        size: 'small',
        buttons: [{id: PromptControl.OK, text: PromptControlText.OK}],
        onClose: _ => null
    };

    static propTypes = {
        title: PropTypes.string,
        description: PropTypes.string,
        theme: PropTypes.oneOf([]),
        size: PropTypes.oneOf(['small', 'medium', 'large', 'wide']),
        buttons: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({id: PropTypes.string, text: PropTypes.string})])),
        onClose: PropTypes.func
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return true;
    }

    render() {
        const {state, ref} = this;

        return <Modal className={`Prompt ${state.theme}`}
                      ref={ref.modal}
                      name={'Prompt'}
                      size={state.size}
                      title={state.title}
                      description={state.description}>
            <ModalContent/>
            <ModalControls>
                {state.buttons.map((item, index) => <Button key={index} className={'mar-4'} theme={'gray'} id={item.id} onClick={this.promptButtonClickHandler.bind(this, item)}>{item.text}</Button>)}
            </ModalControls>
        </Modal>;
    }

    open(props) {
        return new Promise((resolve, reject) => {
            const buttons = [];

            props = {
                ...Prompt.defaultProps,
                ...this.props,
                ...props
            };

            if (typeof props.buttons === "string")
                switch (props.buttons) {
                    case PromptControl.YES_NO:
                        buttons.push(this.publishButton(PromptControl.YES));
                        buttons.push(this.publishButton(PromptControl.NO));
                        break;
                    case PromptControl.YES_NO_CANCEL:
                        buttons.push(this.publishButton(PromptControl.YES));
                        buttons.push(this.publishButton(PromptControl.NO));
                        buttons.push(this.publishButton(PromptControl.CANCEL));
                        break;
                    case PromptControl.OK_CANCEL:
                        buttons.push(this.publishButton(PromptControl.OK));
                        buttons.push(this.publishButton(PromptControl.CANCEL));
                        break;
                    default:
                        buttons.push(this.publishButton(props.buttons));
                }
            else
                for (const button of props.buttons)
                    switch (button) {
                        case PromptControl.YES_NO:
                            buttons.push(this.publishButton(PromptControl.YES));
                            buttons.push(this.publishButton(PromptControl.NO));
                            break;
                        case PromptControl.YES_NO_CANCEL:
                            buttons.push(this.publishButton(PromptControl.YES));
                            buttons.push(this.publishButton(PromptControl.NO));
                            buttons.push(this.publishButton(PromptControl.CANCEL));
                            break;
                        case PromptControl.OK_CANCEL:
                            buttons.push(this.publishButton(PromptControl.OK));
                            buttons.push(this.publishButton(PromptControl.CANCEL));
                            break;
                        default:
                            buttons.push(this.publishButton(button));
                    }

            this.setState({resolve, reject, ...props, buttons});

            this.ref.modal.current.open();
        });
    }

    close() {
        this.props.onClose({id: PromptControl.CANCEL, text: PromptControlText.CANCEL});
        this.props.reject({id: PromptControl.CANCEL, text: PromptControlText.CANCEL});

        this.ref.modal.current.close();
    }

    publishButton(button) {
        if (button) {
            if (typeof button === "string")
                if (PromptControl[button])
                    return {id: button, text: PromptControlText[button]};
                else
                    return {};
            else
                return {id: button.id, text: button.text};
        }
        return {};
    }

    promptButtonClickHandler(button, event) {
        this.state.resolve(button);
        this.state.onClose(button);

        this.ref.modal.current.close();
    }
}

export default Prompt
export {PromptControl}